import { takeLatest, take, put } from 'redux-saga/effects';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import { consts as postsList } from './postsList';

export const consts = createReqConsts('communities', 'deletePost');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
    'posts',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

export default createReqReducer(consts);

function* deletedPostWorker(action) {
  yield take(consts.SUCCEED);
  yield put({
    type: postsList.DELETE_POST,
    payload: action.payload,
  });
}

export function* deletedPostSaga() {
  yield takeLatest(consts.SEND, deletedPostWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/deletePost.js